import { AnchorSettings } from './types';

const commonSettings = {
  fontWeight: 2,
  fontFamily: 'secondary',
  color: 'primary.main',
  borderRadius: 1,
  '&:focus-visible': {
    outlineColor: 'primary.light',
    outlineStyle: 'solid',
    outlineWidth: '3px',
  },
  '&:hover': {
    color: 'primary.dark',
  },
};

export const anchorSettings: AnchorSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        small: {
          fontSize: '0',
          lineHeight: '0',
          columnGap: '2',
          ...commonSettings,
        },
        medium: {
          fontSize: '1',
          lineHeight: '1',
          columnGap: '3',
          ...commonSettings,
        },
      },
    },
    iconSize: {
      prop: 'iconSize',
      variants: {
        small: {
          width: '0',
          height: '0',
        },
        medium: {
          width: '1',
          height: '1',
        },
      },
    },
  },
};
